"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkExperienceSection = void 0;
const react_1 = __importStar(require("react"));
const WebformFieldRouter_1 = require("../WebformFieldRouter");
const WorkExperienceSection = ({ section, data, errors, onChange, disabled, lookups, }) => {
    const workData = data.workExperience || [{}];
    const updateRow = (0, react_1.useCallback)((rowIdx, field, value) => {
        const updated = [...workData];
        if (!updated[rowIdx])
            updated[rowIdx] = {};
        updated[rowIdx][field] = value;
        onChange('workExperience', updated);
    }, [workData, onChange]);
    const addRow = (0, react_1.useCallback)(() => {
        if (workData.length >= section.maxRows)
            return;
        onChange('workExperience', [...workData, {}]);
    }, [workData, section.maxRows, onChange]);
    const removeRow = (0, react_1.useCallback)((idx) => {
        onChange('workExperience', workData.filter((_, i) => i !== idx));
    }, [workData, onChange]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        workData.map((row, idx) => (react_1.default.createElement("div", { key: idx, className: "repeatable-row" },
            react_1.default.createElement("div", { className: "repeatable-row-header" },
                react_1.default.createElement("div", { className: "repeatable-row-title" },
                    "Experience ",
                    idx + 1),
                !disabled && workData.length > 1 && (react_1.default.createElement("button", { type: "button", className: "wf-btn-remove", onClick: () => removeRow(idx) }, "Remove"))),
            react_1.default.createElement("div", { className: "form-row" }, (section.fields || []).map((field) => (react_1.default.createElement("div", { key: field.key },
                react_1.default.createElement(WebformFieldRouter_1.WebformFieldRouter, { field: {
                        key: `work_${idx}_${field.key}`,
                        label: field.label,
                        type: field.type || 'text',
                        required: field.required,
                    }, value: row[field.key] || '', onChange: (_key, val) => updateRow(idx, field.key, val), error: errors[`workExperience.${idx}.${field.key}`], disabled: disabled, lookups: lookups })))))))),
        !disabled && workData.length < section.maxRows && (react_1.default.createElement("button", { type: "button", className: "wf-btn-add", onClick: addRow }, "+ Add Experience"))));
};
exports.WorkExperienceSection = WorkExperienceSection;
